<template>
<div id="layout_apendices">
  <div>
    <v-breadcrumbs :items="parametros.breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-top justify-top>
      <v-menu-lateral-apendice />
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" :title="parametros.title" class="px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-speed-dial direction="left" open-on-hover>
              <template v-slot:activator>
                <v-btn x-small fab dark color="primary">
                  <v-icon>reorder</v-icon>
                </v-btn>
              </template>
              <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="parametros.camposexcel" :name="parametros.title + '.xlsx'">
                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                  <v-icon dark>get_app</v-icon>
                </v-btn>
              </exportar-excel>
              <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
              <exportar-excel v-if="editable" :data="parametros.camposLayout" :exportFields="parametros.encabezadoLayout" :name="'Layout ' + parametros.title + '.xlsx'">
                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                  <v-icon dark>receipt</v-icon>
                </v-btn>
              </exportar-excel>
            </v-speed-dial>

            <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>
          <v-dialog v-model="modal" max-width="50%" style=" z-index: 400 !important;">
            <v-card>
              <v-card-title>
                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modal = false" class="close_modal">
                  <v-icon class="white--text">cancel</v-icon>
                </v-btn>
              </v-card-title>
              <v-form ref="form" lazy-validation>
                <v-card-text>
                  <v-container grid-list-md text-xs-center @keyup.enter="guardar()">
                    <v-layout row wrap v-for="(item, index) in this.parametros.form" :key="index">
                      <v-flex v-if="item.tipo != undefined && item.tipo == 'checkbox'" s12 m6 l6>
                        <v-checkbox :name="item" v-model="item.value" :false-value="0" :true-value="1" :label="item.label"></v-checkbox>
                      </v-flex>
                      <v-flex v-else s12 m6 l6>
                        <v-text-field :name="item" :label="item.label" type="text" v-model="item.value" @input="item.value = item.value.toUpperCase()" :rules="item.requiered ? [rules.required] : []" :maxlength="item.maxlen"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false">
                  <v-icon>cancel</v-icon>Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" @click.native="guardar()">
                  <v-icon>done</v-icon>
                  {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="datos.items" :columns="parametros.columns" :options="parametros.options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial v-if="((id_cliente == 0 && props.row.cliente==null) || (props.row.cliente == id_cliente))" direction="left" :open-on-hover="true">
                    <v-btn slot="activator" x-small fab dark color="primary">
                      <v-icon>reorder</v-icon>
                    </v-btn>

                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";

import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
  props: {
    parametros: {
      type: Object
    }
  },
  data: () => ({
    fab: false,
    name: "datagrid",
    importData: [],

    show_loading: true,
    loading: false,
    modal: false,
    update: false,
    url_active: location.href,
    id_cliente: 0,
    editable: true,
    datos: {
      items: []
    },
    rules: {
      required: v => !!v || "Este campo es requerido"
    }
  }),
  components: {
    "v-power-titulo": powerTitulo,
    "v-menu-lateral-apendice": menuLateral
  },
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.datos.items;
      }
    }
  },
  methods: {
    render(url) {
      this.$router.push(url);
    },
    openModal: function(type) {
      if (type === 1) {
        this.limpiarModel();
        this.update = false;
      } else {
        this.update = true;
      }
      this.modal = true;
    },

    limpiarModel: function() {
      for (var k in this.parametros.model) {
        this.parametros.model[k] = "";
      }
      for (var k in this.parametros.model) {
        if (Object.keys(this.parametros.form).includes(k))
          this.parametros.form[k].value = "";
      }
      //   this.parametros.model.cliente = this.$local_storage.get("id_cliente");

      if (this.parametros.tabla == 30) {
        this.parametros.model = {
          id: "",
          numero: "",
          clave: "",
          nombre: "",
          clave_pedimento: 0,
          porcentaje_retorno: 0,
          rfc: ""
        };

        this.parametros.form = {
          numero: {
            requiered: false,
            label: "Número",
            value: "",
            maxlen: 10
          },
          clave: {
            requiered: true,
            label: "Clave",
            value: "",
            maxlen: 50
          },
          nombre: {
            requiered: true,
            label: "Nombre",
            value: "",
            maxlen: 350
          },
          rfc: {
            requiered: false,
            label: "RFC",
            value: "",
            maxlen: 20
          },
          clave_pedimento: {
            required: true,
            label: "¿Es Clave de Pedimento?",
            value: 0,
            tipo: "checkbox"
          },
          porcentaje_retorno: {
            required: true,
            label: "¿Tiene porcentaje de retorno?",
            value: 0,
            tipo: "checkbox"
          }
        }
      }
    },

    guardar() {
      var datos = this.parametros.model;
      datos["tabla"] = this.parametros.tabla;
      let id_cliente = this.$local_storage.get("id_cliente");
      var obj = this.parametros.form;
      for (var [key, valores] of Object.entries(obj)) {
        datos[key] = valores.value;
        datos["cliente"] = id_cliente == 0 ? null : id_cliente;
      }

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var metodo = "post";
        var urlCliente = this.URL;
        if (this.update == true) {
          metodo = "put";
          urlCliente += this.parametros.model.id + "/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
          })
          .catch(error => {
            var errores = "";
            if (typeof error.response.data != "undefined") {
              Object.keys(error.response.data).forEach(function(key) {
                for (var k in error.response.data[key]) {
                  errores += key + ": " + error.response.data[key][k];
                  errores += "<br>";
                }
              });
            }
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos",
              footer: errores
              //showConfirmButton: false,
            });
            //console.log(error);
          })
          .then(() => {
            this.cargar();
            this.$root.$dialogLoader.hide();
            this.modal = false;
          });
      }
    },

    cargar: function() {
      if (this.parametros.tabla == 30) {
        var datos = {
          tabla: this.parametros.tabla,
          rfc: this.$local_storage.get("rfc")
        };
      } else {
        var datos = {
          tabla: this.parametros.tabla
        };
      }

      axios
        .post(this.$hostname + this.parametros.url_list, datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos.items = res.data;
          }
        })
        .catch(err => {

          console.log(err);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getRegistro: function(id_registro) {
      let tabla = this.parametros.tabla;
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .get(this.URL + id_registro + "/", {
          params: {
            tabla: tabla
          }
        })
        .then(response => {
          this.parametros.model = response.data;
          var obj = response.data;
          for (var [key, value] of Object.entries(obj)) {
            if (Object.keys(this.parametros.form).includes(key))
              this.parametros.form[key].value = value;
          }
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro",
            footer: ""
          });
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro

    deleteRegistro: function(id_registro) {
      let tabla = this.parametros.tabla;
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
          axios
            .delete(this.URL + id_registro + "/", {
              params: {
                tabla: tabla
              }
            })
            .then(response => {
              this.cargar();
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                //position: 'bottom-end',
                //timer: 3000,
                //showConfirmButton: false,
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro",
                footer: ""
              });
            })
            .then(() => {
              this.$root.$dialogLoader.hide();
            });
        }
      });
    }, //delete
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isLt2M) {
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },
    handleSuccess({
      results,
      header
    }) {
      //Los clientes no pueden modificar los apendices, excepto el de 2-Unidades de Medida y (por definir PILOS)
      this.importData = results;

      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let tabla = this.parametros.tabla;
      axios
        .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
        .then(() => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "Los datos se guardaron correctamente",
            footer: ""
          });
        })
        .catch(err => {
          var errores = "";
          if (typeof err.response.data != "undefined") {
            for (var i = 0; i < err.response.data.length; i++) {
              Object.keys(err.response.data[i]).forEach(function(key) {
                errores +=
                  "Fila " +
                  (i + 2) +
                  " => " +
                  key +
                  ": " +
                  err.response.data[i][key];
                errores += "<br>";
              });
            }
          }
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
            footer: errores
          });
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
          this.cargar();

        });
    }
  }, //methods

  created: function() {
    this.URL = this.$hostname + this.parametros.url_actions;
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.id_cliente = this.$local_storage.get("id_cliente");
    if (this.id_cliente > 0 && this.parametros.tabla != 2) {
      //Los clientes no pueden modificar los apendices, excepto el de 2-Unidades de Medida y (por definir PILOS)
      this.editable = false;
      delete this.parametros.options.headings["actions"];
      var key = 0;
      for (var k in this.parametros.columns) {
        if (this.parametros.columns[k] == "actions") key = k;
      }
      if (key > 0) delete this.parametros.columns[key];
    }
    this.cargar();
  }
};
</script>

<style>
.VueTables__limit {
  display: none;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
